export type {
    CosmosDataModel,
    CoreProjection,
    RuntimeState,
    Config,
} from '@/adapters/core/_contract/config';
export {
    CONFIG,
} from '@/adapters/core/_data/config/config';
export {
    RESOURCE_TYPE_INPUT_SPEC,
    getResourceTypeInputSpec,
} from '@/adapters/core/_pure/resourceTypeInputSpec';
export {
    SPACE_SLUG,
    SPACE_KEY,
} from '@/adapters/core/spaceIdentity';
export {
    spaceAdapter,
    DESCRIPTOR,
    type AdapterDescriptor,
} from '@/adapters/core/registryInput';
export { buildCosmosData } from '@/adapters/core/_pure/cosmosData';
export { createSpaceDeriver } from '@/adapters/core/framePipeline';
export { runtimeController, createInitialRuntimeState } from '@/adapters/core/runtime';